import { graphQueryBang, graphQuery, gql } from "shared/lib/graphql"

export const SubscriptionUpdateMutation = gql`
  mutation ($product_id: String!) {
    userSubscriptionUpdate(input: { product_id: $product_id }) {
      user_subscription {
        plan_id
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const TierPricesQuery = gql`
  query {
    tier_prices {
      pro {
        month {
          currency
          formatted
          formatted_monthly
        }

        year {
          currency
          formatted
          formatted_monthly
        }
      }
    }
  }
`

type updateSubscriptionPlanProps = {
  productId: string
}

export const updateSubscriptionPlan = async ({ productId }: updateSubscriptionPlanProps) => {
  const graphConfigs = { awaitClearCache: true }
  const response = await graphQueryBang(
    SubscriptionUpdateMutation,
    {
      product_id: productId,
    },
    graphConfigs
  )
  return response.userSubscriptionUpdate
}

export const loadTierPrices = async () => {
  const response = await graphQuery(TierPricesQuery)
  return response.data.tier_prices.pro
}

export const loadSubscriptionInterval = async (url: string) => {
  return fetch(url, {
    headers: { "Content-Type": "application/json" },
  }).then(response => response.json())
}
